import React, { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import styles from './Avatar.module.scss';

export const getInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const Avatar = ({ src, fallbackSrc, name, alt, size = 'md', className, ...props }) => {
  const sources = useMemo(() => [src, fallbackSrc].filter(Boolean), [src, fallbackSrc]);
  const [sourceIndex, setSourceIndex] = useState(0);
  const currentSource = sources[sourceIndex];

  useEffect(() => setSourceIndex(0), [src, fallbackSrc]);

  return (
    <span
      className={clsx(styles.avatar, styles[size], className)}
      role={currentSource ? undefined : 'img'}
      aria-label={alt || name || 'Profile'}
      {...props}
    >
      {currentSource ? (
        <img
          src={currentSource}
          alt={alt || name || ''}
          onError={() => setSourceIndex((index) => index + 1)}
        />
      ) : (
        <span className={styles.initials} aria-hidden="true">{getInitials(name)}</span>
      )}
    </span>
  );
};

export default Avatar;
